<template lang="pug">
  b-container.lmm-content-body-padded(fluid)
    b-row
      b-col.page-wrap(cols="12")
        b-card(no-body)
          b-list-group(flush)
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('department')}} {{$t('name')}}
                b-col(cols="9")
                  editable(
                    name="part_name",
                    :value="form.part_name"
                    :wait="wait.part_name"
                    @changed="valueChange"
                    :disabled="true"
                  )
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('user_page.department_head')}}({{$t('mid_manager')}})
                b-col(cols="9")
                  div {{ form.leader_manager_name }}
                  b-btn.otp-reset-button(size="sm" @click="showDialogApprover = true") {{$t('selection')}}
            //- b-list-group-item
              b-row
                b-col(cols="3") 결재프로세스 적용
                b-col.btns(cols="9")
                  b-btn(size="sm" variant="primary" @click="allChange('flag_use_approval', 1)") {{$t('user_page.bulk_apply')}}
                  b-btn(size="sm" @click="allChange('flag_use_approval', 0)") {{$t('user_page.bulk_retrieval')}}
            b-list-group-item
              b-row
                b-col(cols="3") {{$t('user_page.post_approval_permission')}}
                b-col.btns(cols="9")
                  b-btn(size="sm" variant="primary" @click="allChange('post_approval', 1)") {{$t('user_page.bulk_apply')}}
                  b-btn(size="sm" @click="allChange('post_approval', 0)") {{$t('user_page.bulk_retrieval')}}
            //- b-list-group-item
              b-row
                b-col(cols="3") 원격제어권한
                b-col.btns(cols="9")
                  b-btn(size="sm" variant="primary" @click="allChange('auth_remotecontrol', 1)") {{$t('user_page.bulk_apply')}}
                  b-btn(size="sm" @click="allChange('auth_remotecontrol', 0)") {{$t('user_page.bulk_retrieval')}}
            //- b-list-group-item
              b-row
                b-col(cols="3") 파일전송권한
                b-col.btns(cols="9")
                  b-btn(size="sm" variant="primary" @click="allChange('auth_filemanager', 1)") {{$t('user_page.bulk_apply')}}
                  b-btn(size="sm" @click="allChange('auth_filemanager', 0)") {{$t('user_page.bulk_retrieval')}}
        
        department-user-grid(ref="grid" :options="{ title: $t('user_page.department_members'), checked: true }" :departmentName="form.part_name" :pk="id")
        dialog-approver(
          :show.sync="showDialogApprover"
          :title="String($t('user_page.select_department_head'))"
          :data="{ context: 'middle_manager_list_modal' }"
          @select="selectApprover"
        )
</template>

<script>
import { DepartmentsAPI } from "@/api"
import Editable from "@/components/mixins/editable"
import DepartmentUserGrid from "../components/gridDepartmentUser.vue"
import DialogApprover from "../components/dialogApprover.vue"

export default {
  components: {
    Editable,
    DepartmentUserGrid,
    DialogApprover,
  },
  data() {
    return {
      id: null,
      showDialogApprover: false,
      form: {
        part_name: null,
        leader_manager_name: null,
      },
      wait: {
        part_name: false,
      },
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.fetchData()
  },
  methods: {
    fetchData() {
      DepartmentsAPI.get(`${this.id}`).then(res => {
        this.form = res.data.objects
      })
    },
    valueChange(key, value) {
      this.form[key] = value
      let params = {
        request_type: 0,
      }
      params[key] = value
      DepartmentsAPI.put(`${this.id}`, params)
    },
    allChange(key, value) {
      let params = {
        request_type: 0,
      }
      params[key] = value
      DepartmentsAPI.put(`user/${this.id}`, params).then(_ => {
        this.$refs.grid.$refs.userTable.refresh()
      })
    },
    selectApprover(data) {
      const params = {
        // input_type: "department_head_update",
        leader_manager_fk: data.pk,
      }
      DepartmentsAPI.put(`${this.id}`, params).then(res => {
        this.form.leader_manager_name = data.name
        this.showDialogApprover = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.row,
.col,
.container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  //.card-footer {
  //  border-top: none;
  //  padding: 0.3rem 1.25rem;
  //}
}
.otp-reset-button {
  position: absolute;
  top: -6px;
  right: 5px;
}
.btns {
  button {
    min-width: 100px;
  }
  button + button {
    margin-left: 10px;
  }
}
</style>
